import './SonarCardTabs.scss';
import classNames from 'classnames';
import { SonarCard } from './SonarCard';
import { Tabs } from 'antd';
import { useFeatureFlags } from '@hooks';
import React, { useMemo, useState } from 'react';
export const SonarCardTabs = ({ className, defaultKey, extra, items, title }) => {
    var _a, _b;
    const { isEnabled } = useFeatureFlags();
    const managedItems = useMemo(() => items.map((item) => (Object.assign(Object.assign({}, item), { disabled: item.featureFlag ? !isEnabled(item.featureFlag) : item.disabled }))), [isEnabled, items]);
    const [activeKey, setActiveKey] = useState(defaultKey !== null && defaultKey !== void 0 ? defaultKey : (_a = managedItems.find((item) => !item.disabled)) === null || _a === void 0 ? void 0 : _a.key);
    const activeExtra = (_b = managedItems.find((item) => item.key === activeKey)) === null || _b === void 0 ? void 0 : _b.extra;
    return (React.createElement(SonarCard, { className: classNames('sonar-card-tabs', className), extra: activeExtra === undefined ? extra : activeExtra, noSpacing: true, title: title },
        React.createElement(Tabs, { activeKey: activeKey, className: 'sonar-tabs', items: managedItems, onChange: setActiveKey })));
};
